(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("rabbit", [], factory);
	else if(typeof exports === 'object')
		exports["rabbit"] = factory();
	else
		root["rabbit"] = factory();
})(self, function() {
return 